var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLeave(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 15.245,
    height: 20.006,
    viewBox: "0 0 15.245 20.006",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_500",
    "data-name": "Group 500",
    transform: "translate(-1315.746 730.038)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1363",
    "data-name": "Path 1363",
    d: "M1317.623-710.032a4.781,4.781,0,0,1-.762-.277,2.072,2.072,0,0,1-1.111-1.906c-.007-1.419,0-2.838,0-4.258q0-5.674,0-11.348a2.138,2.138,0,0,1,1.66-2.154,2.457,2.457,0,0,1,.56-.059c2.344,0,4.688,0,7.031,0a2.236,2.236,0,0,1,1.6.641q1.805,1.715,3.619,3.421a2.326,2.326,0,0,1,.766,1.787c-.006,3.965-.012,7.93,0,11.894a2.178,2.178,0,0,1-1.831,2.234c-.018,0-.033.018-.05.028Zm7.267-18.833h-6.86a.992.992,0,0,0-1.111,1.106q0,7.726,0,15.452a.99.99,0,0,0,1.094,1.1h10.7a.991.991,0,0,0,1.094-1.1q0-5.821,0-11.643v-.226h-.23q-1.631,0-3.262,0a1.367,1.367,0,0,1-1.43-1.422c0-.742,0-1.484,0-2.227Zm1.183.582c-.006.066-.011.091-.011.115q0,1.278,0,2.556c0,.2.065.262.274.262q1.327,0,2.653,0c.046,0,.092-.01.166-.018Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1364",
    "data-name": "Path 1364",
    d: "M1370.79-556.685q-2.128,0-4.255,0a.583.583,0,0,1-.554-.86.579.579,0,0,1,.546-.311h1.991q3.26,0,6.52,0a.584.584,0,0,1,.577.834.594.594,0,0,1-.588.338q-2.04,0-4.08,0Z",
    transform: "translate(-47.541 -163.194)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1365",
    "data-name": "Path 1365",
    d: "M1370.762-496.8q-2.118,0-4.236,0a.583.583,0,0,1-.57-.828.579.579,0,0,1,.565-.344h2.44q3.036,0,6.071,0a.585.585,0,0,1,.584.819.6.6,0,0,1-.6.354Q1372.89-496.8,1370.762-496.8Z",
    transform: "translate(-47.534 -219.951)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1366",
    "data-name": "Path 1366",
    d: "M1362.462-683.335c0-.39,0-.754,0-1.117a.592.592,0,0,1,.588-.641.594.594,0,0,1,.583.646c0,.351,0,.7,0,1.055a.265.265,0,0,0,.02.057c.374,0,.756-.005,1.138,0a.58.58,0,0,1,.527.853.574.574,0,0,1-.542.317c-.376,0-.752,0-1.146,0,0,.375,0,.732,0,1.088a.6.6,0,0,1-.579.67.6.6,0,0,1-.593-.676c0-.351,0-.7,0-1.082h-.839c-.1,0-.208,0-.312,0a.591.591,0,0,1-.606-.584.587.587,0,0,1,.6-.587C1361.683-683.339,1362.059-683.335,1362.462-683.335Z",
    transform: "translate(-42.611 -42.599)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1367",
    "data-name": "Path 1367",
    d: "M1367.955-438.1c.456,0,.912,0,1.368,0a.6.6,0,0,1,.635.576.6.6,0,0,1-.637.594q-1.377,0-2.754,0a.588.588,0,0,1-.623-.586.589.589,0,0,1,.625-.584C1367.031-438.1,1367.493-438.1,1367.955-438.1Z",
    transform: "translate(-47.578 -276.699)",
    fill: "#fff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLeave);
export default __webpack_public_path__ + "static/media/Leave.70087ad23e49d60a5726019b0ddf3aef.svg";
export { ForwardRef as ReactComponent };